import clsx from 'clsx'

interface Props {
	buttons: {
		label: string
		isActive: boolean
		value?: any
		number?: number
		numberColor?: 'green' | 'white' | 'grey'
	}[]
	onClick?: (val: any) => void
}

const ButtonFilter: React.FC<Props> = ({ buttons, onClick }) => {
	const activeClassName = 'btn-kumopack-secondary-400 text-kumopack-base-white'
	const inactiveClassName = 'white-button text-kumopack-grey-700'

	return (
		<div className="d-flex flex-row">
			{buttons.map((button, index) => (
				<button
					onClick={() => {
						if (onClick && button.value !== undefined) {
							onClick(button.value)
						}
					}}
					key={`button-filter-${index}`}
					className={clsx('btn btn-sm fw-bold me-2', {
						[activeClassName]: button.isActive,
						[inactiveClassName]: !button.isActive,
						'border-width-0': !button.isActive,
					})}>
					{button.label}

					{button.number !== undefined && (
						<span
							className={clsx(
								'ms-2 badge badge-kumopack-base-white text-kumopack-secondary-900 border-radius-16px',
								{
									'badge-kumopack-base-white text-kumopack-secondary-900':
										button.numberColor === 'white' || button.numberColor === undefined,
									'badge-kumopack-success-50 text-kumopack-success-700':
										button.numberColor === 'green',
									'badge-kumopack-grey-50 text-kumopack-grey-700': button.numberColor === 'grey',
								}
							)}
							style={{ padding: '4px 8px' }}>
							{button.number}
						</span>
					)}
				</button>
			))}
		</div>
	)
}

export default ButtonFilter
